import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=0a890571&scoped=true&"
var script = {}
import style0 from "./Search.vue?vue&type=style&index=0&id=0a890571&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a890571",
  null
  
)

export default component.exports